import { compose } from 'redux';

// Devtools
// Always enable devtools in development
const composer =
  process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

export { composer as compose };
